/**
 * Resolvable promise for print
 */
class ResolvablePromise {
  /**
   * Promise
   */
  public readonly promise: Promise<unknown>;

  /**
   * Resolve function
   */
  public readonly resolve: () => unknown;

  /**
   * Constructor
   * @param promise
   * @param resolve
   */
  constructor(promise: Promise<unknown>, resolve: () => unknown) {
    this.promise = promise;
    this.resolve = resolve;
  }

  /**
   * Creates a new promise
   * @returns
   */
  public static create(): ResolvablePromise {
    let resolve;
    const promise = new Promise(innerResolve => {
      resolve = innerResolve;
    });

    const resolvablePromise = new ResolvablePromise(promise, resolve);
    return resolvablePromise;
  }
}

/*
Async lock for print
Usage:
async processAsync(n: number) {
  	await lock.acquire();
  	try {
      console.log(`StartAsync ${n}`);
      await this.timeout(500);
      console.log(`EndAsync ${n}`);
    } finally {
    	lock.release();
    }
  }
*/
export class AsyncLock {
  /**
   * Promises to be resolved
   */
  private resolvablePromises: ResolvablePromise[] = [];

  /**
   * Acquire the lock
   * @returns
   */
  acquire() {
    const resolvablePromise = ResolvablePromise.create();
    this.resolvablePromises.push(resolvablePromise);
    if (this.resolvablePromises.length === 1) {
      resolvablePromise.resolve();
    }

    return resolvablePromise.promise;
  }

  /**
   * Release the lock
   */
  release() {
    this.resolvablePromises.splice(0, 1);
    if (this.resolvablePromises.length > 0) {
      this.resolvablePromises[0].resolve();
    }
  }
}
